import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ACHIEVEMENT_FEATURE_KEY } from '../keys';
import { AchievementState } from '../reducers/achievement.reducer';

const selectState = createFeatureSelector<AchievementState>(ACHIEVEMENT_FEATURE_KEY);

export const selectNextAchievement = createSelector(selectState, (state: AchievementState) => state.next.data);
export const selectNextAchievementLoaded = createSelector(selectState, (state: AchievementState) => state.next.loaded);
export const selectNextAchievementLoading = createSelector(selectState, (state: AchievementState) => state.next.loading);

export const selectLatestAchievements = createSelector(selectState, (state: AchievementState) => state.latest.data);
export const selectLatestAchievementsLoaded = createSelector(selectState, (state: AchievementState) => state.latest.loaded);
export const selectLatestAchievementsLoading = createSelector(selectState, (state: AchievementState) => state.latest.loading);
